import axios from 'axios'
import { constants } from '../../App.constants'

/**
 * POST /organization/:orgId/member/linkAccount (dashboards-api).
 *
 * Links the signed-in account to the member's existing orgStripeCustomers row
 * by email, after an admin-managed member signs up from a renewal link. The
 * API takes identity from the login token only, and never creates a Stripe
 * customer or subscription.
 *
 * cb(null, { customerId, allcalUserId, linked }) on success,
 * cb({ status, message }) on failure (401 / 404 / 409 / network).
 */
export const linkMemberAccount = (loginToken, cb) => {
    return async () => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': loginToken
            }
        }
        try {
            const payload = await axios.post(
                constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/member/linkAccount',
                {},
                headers
            )
            if (payload.data && payload.data.error === false) {
                cb(null, payload.data.data)
                return
            }
            cb({ status: payload.status, message: (payload.data && payload.data.message) || 'Could not link the account' })
        } catch (error) {
            const status = error && error.response ? error.response.status : undefined
            const message = error && error.response && error.response.data && error.response.data.message
            cb({ status, message: message || 'Could not link the account' })
        }
    }
}
